import React from "react";
import { motion } from "framer-motion";
import { BookOpen, UserPlus, Download, MapPin, HandCoins, ArrowRight } from "lucide-react";
import { trackBookDownload } from "../lib/trackBookDownload";

const BOOK_PDF =
  "https://customer-assets.emergentagent.com/job_ya-digital/artifacts/riplp2t7_Resumen_por_capitulos_Capitalismo_de_Abundancia.pdf";

export const HERO_CTA_ITEMS = [
  {
    id: "propuesta",
    label: "Conocé la propuesta",
    icon: BookOpen,
    target: "doctrina",
    primary: true,
  },
  {
    id: "voluntario",
    label: "Sumate como voluntario",
    icon: UserPlus,
    target: "sumate",
  },
  {
    id: "manifiesto",
    label: "Descargá el manifiesto",
    icon: Download,
    href: BOOK_PDF,
    external: true,
  },
  {
    id: "organizar",
    label: "Organizá Frente Ya en tu ciudad",
    icon: MapPin,
    target: "organizar",
  },
  {
    id: "aportar",
    label: "Aportá a la campaña",
    icon: HandCoins,
    target: "aportar",
  },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const HeroCTAs = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, delay: 0.45 }}
      className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3"
      data-testid="hero-ctas"
    >
      {HERO_CTA_ITEMS.map((item) => {
        const Icon = item.icon;
        const base =
          "group relative flex items-center gap-3 px-5 py-4 border font-headings uppercase tracking-wide text-[11px] sm:text-xs leading-tight text-left transition-all";
        const styles = item.primary
          ? "bg-[#F5B400] hover:bg-[#d99f00] border-[#F5B400] text-[#0A192F]"
          : "bg-white/5 hover:bg-white/10 border-white/25 hover:border-[#F5B400] text-white";

        const content = (
          <>
            <Icon size={18} className={item.primary ? "text-[#0A192F]" : "text-[#F5B400]"} />
            <span className="flex-1">{item.label}</span>
            <ArrowRight
              size={14}
              className={`shrink-0 ${
                item.primary ? "text-[#0A192F]" : "text-white/60 group-hover:text-[#F5B400]"
              } group-hover:translate-x-1 transition-transform`}
            />
          </>
        );

        if (item.external) {
          return (
            <a
              key={item.id}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => item.id === "manifiesto" && trackBookDownload("hero-cta")}
              className={`${base} ${styles}`}
              data-testid={`hero-cta-${item.id}`}
            >
              {content}
            </a>
          );
        }
        return (
          <button
            key={item.id}
            onClick={() => scrollTo(item.target)}
            className={`${base} ${styles}`}
            data-testid={`hero-cta-${item.id}`}
          >
            {content}
          </button>
        );
      })}
    </motion.div>
  );
};

export default HeroCTAs;
